// Direct DOM manipulation approach for mobile toggle
let processingToggle = false;
let lastToggleState = null;
let isSearchPage = false;

function detectPageType() {
  const urlParams = new URLSearchParams(window.location.search);
  const hasSearchQuery = urlParams.has('q') && urlParams.get('q').trim() !== '';
  const isSearchPath = window.location.pathname.includes('/search');
  
  isSearchPage = hasSearchQuery || isSearchPath;
  
  if (!isSearchPage) {
    const searchElements = document.querySelector('#shopify-section-search-template') || 
                          document.querySelector('[data-search-template]') ||
                          document.querySelector('.search-template');
    if (searchElements) {
      isSearchPage = true;
    }
  }
  
  return isSearchPage;
}

function handleInStockToggle(checkbox) {
  if (processingToggle) {
    checkbox.checked = lastToggleState;
    return;
  }
  
  processingToggle = true;
  lastToggleState = checkbox.checked;
  
  // Immediately sync both toggles
  syncToggleStates(lastToggleState);
  
  const isMobile = checkbox.id === 'in-stock-toggle-mobile' || window.innerWidth <= 749;
  
  if (isMobile) {
    handleMobileToggleDirect(lastToggleState);
  } else {
    handleDesktopToggle(lastToggleState);
  }
}

function syncToggleStates(state) {
  const desktopToggle = document.getElementById('in-stock-toggle-desktop');
  const mobileToggle = document.getElementById('in-stock-toggle-mobile');
  
  if (desktopToggle && desktopToggle.checked !== state) {
    desktopToggle.checked = state;
  }
  if (mobileToggle && mobileToggle.checked !== state) {
    mobileToggle.checked = state;
  }
}

function handleMobileToggleDirect(state) {
  // Find the actual mobile form - try multiple selectors
  const possibleForms = [
    document.querySelector('#FacetFiltersFormMobile'),
    document.querySelector('.mobile-facets form'),
    document.querySelector('menu-drawer form'),
    document.querySelector('facet-filters-form form')
  ];
  
  let mobileForm = null;
  for (let form of possibleForms) {
    if (form && form.closest('.mobile-facets')) {
      mobileForm = form;
      break;
    }
  }
  
  if (mobileForm) {
    processMobileForm(mobileForm, state);
  } else {
    handleDirectUrlToggle(state);
  }
}

function processMobileForm(formElement, state) {
  // Get the actual form element
  let form = formElement;
  if (formElement.tagName !== 'FORM') {
    form = formElement.querySelector('form');
  }
  
  if (!form) {
    handleDirectUrlToggle(state);
    return;
  }
  
  // Clean existing availability inputs
  const existingInputs = form.querySelectorAll('input[name*="availability"]');
  existingInputs.forEach(input => input.remove());
  
  // Add availability filter if enabled
  if (state) {
    const availabilityInput = document.createElement('input');
    availabilityInput.type = 'hidden';
    availabilityInput.name = 'filter.v.availability';
    availabilityInput.value = '1';
    availabilityInput.setAttribute('data-mobile-toggle', 'true');
    form.appendChild(availabilityInput);
  }
  
  // Handle search parameters
  if (isSearchPage) {
    addSearchParams(form);
  }
  
  // Handle vendor/type params
  addVendorTypeParams(form);
  
  // Try to submit using FacetFiltersForm
  const facetForm = form.closest('facet-filters-form');
  if (facetForm && typeof facetForm.onSubmitForm === 'function') {
    submitViaFacetForm(facetForm, form);
  } else {
    handleDirectUrlToggle(state);
  }
}

function addSearchParams(form) {
  const searchQuery = new URLSearchParams(window.location.search).get('q');
  if (searchQuery && !form.querySelector('input[name="q"]')) {
    const queryInput = document.createElement('input');
    queryInput.type = 'hidden';
    queryInput.name = 'q';
    queryInput.value = searchQuery;
    form.appendChild(queryInput);
    
    const prefixInput = document.createElement('input');
    prefixInput.type = 'hidden';
    prefixInput.name = 'options[prefix]';
    prefixInput.value = 'last';
    form.appendChild(prefixInput);
  }
}

function addVendorTypeParams(form) {
  const urlParams = new URLSearchParams(window.location.search);
  
  if (urlParams.has('vendor') && !form.querySelector('input[name="q"][value*="' + urlParams.get('vendor') + '"]')) {
    const vendorInput = document.createElement('input');
    vendorInput.type = 'hidden';
    vendorInput.name = 'q';
    vendorInput.value = urlParams.get('vendor');
    form.appendChild(vendorInput);
  }
  
  if (urlParams.has('type') && !form.querySelector('input[name="q"][value*="' + urlParams.get('type') + '"]')) {
    const typeInput = document.createElement('input');
    typeInput.type = 'hidden';
    typeInput.name = 'q';
    typeInput.value = urlParams.get('type');
    form.appendChild(typeInput);
  }
}

function submitViaFacetForm(facetForm, form) {
  try {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    
    // Create a proper event object
    const submitEvent = {
      target: form,
      srcElement: form,
      currentTarget: form,
      preventDefault: () => {},
      stopPropagation: () => {},
      type: 'submit'
    };
    
    facetForm.onSubmitForm(searchParams, submitEvent);
    
    // Reset processing after successful submission
    setTimeout(() => {
      processingToggle = false;
    }, 1000);
    
  } catch (error) {
    handleDirectUrlToggle(lastToggleState);
  }
}

function handleDirectUrlToggle(state) {
  const currentUrl = new URL(window.location);
  
  if (state) {
    currentUrl.searchParams.set('filter.v.availability', '1');
  } else {
    currentUrl.searchParams.delete('filter.v.availability');
  }
  
  // Store toggle state before navigation
  sessionStorage.setItem('pendingToggleState', state.toString());
  
  if (currentUrl.href !== window.location.href) {
    window.location.href = currentUrl.href;
  } else {
    processingToggle = false;
  }
}

function handleDesktopToggle(state) {
  if (state) {
    // Enable: Try multiple approaches in sequence
    if (!addAvailabilityToDesktopForm(true)) {
      const availabilityCheckbox = findAvailabilityCheckbox();
      if (availabilityCheckbox) {
        availabilityCheckbox.checked = true;
        triggerChangeEvents(availabilityCheckbox);
      } else {
        // Fallback to URL method
        handleDirectUrlToggle(state);
        return;
      }
    }
  } else {
    // Disable: Always try form approach first, then fallback methods
    
    // Method 1: Try form-based approach
    if (addAvailabilityToDesktopForm(false)) {
      // Successfully disabled via form
    }
    // Method 2: Try to remove active facet
    else if (removeActiveAvailabilityFacet()) {
      // Successfully disabled via facet removal
    }
    // Method 3: Try checkbox approach
    else {
      const availabilityCheckbox = findAvailabilityCheckbox();
      if (availabilityCheckbox && availabilityCheckbox.checked) {
        availabilityCheckbox.checked = false;
        triggerChangeEvents(availabilityCheckbox);
        
        // Force form submission after checkbox change
        setTimeout(() => {
          const form = availabilityCheckbox.closest('form');
          if (form) {
            const facetForm = form.closest('facet-filters-form');
            if (facetForm && facetForm.onSubmitForm) {
              const formData = new FormData(form);
              const searchParams = new URLSearchParams(formData).toString();
              facetForm.onSubmitForm(searchParams, { target: form });
            }
          }
        }, 100);
      }
      // Method 4: Direct URL manipulation as final fallback
      else {
        handleDirectUrlToggle(state);
        return;
      }
    }
  }
  
  setTimeout(() => {
    processingToggle = false;
  }, 1000);
}

function findAvailabilityCheckbox() {
  const selectors = [
    'input[name="filter.v.availability"][value="1"]',
    'input[name*="availability"][value="1"]',
    'input[data-filter-value="1"][name*="availability"]'
  ];
  
  for (const selector of selectors) {
    const checkbox = document.querySelector(selector);
    if (checkbox) {
      return checkbox;
    }
  }
  return null;
}

function triggerChangeEvents(element) {
  ['change', 'input', 'click'].forEach(eventType => {
    element.dispatchEvent(new Event(eventType, { bubbles: true }));
  });
  
  // Also trigger form submission manually
  setTimeout(() => {
    const form = element.closest('form');
    if (form) {
      const event = new Event('submit', { bubbles: true, cancelable: true });
      form.dispatchEvent(event);
    }
  }, 50);
}

function removeActiveAvailabilityFacet() {
  // Enhanced selectors for facet removal buttons
  const selectors = [
    'facet-remove a[href*="availability"]',
    '.active-facets__button a[href*="availability"]',
    '.facets__remove a[href*="availability"]',
    'a[data-facet-remove][href*="availability"]',
    '.active-facets a[href*="availability"]'
  ];
  
  for (const selector of selectors) {
    const buttons = document.querySelectorAll(selector);
    for (const button of buttons) {
      button.click();
      return true;
    }
  }
  
  // Also try text-based matching
  const allRemoveButtons = document.querySelectorAll('facet-remove a, .active-facets__button a, .facets__remove a');
  
  for (const button of allRemoveButtons) {
    const text = button.textContent.toLowerCase();
    if (text.includes('availability') || 
        text.includes('in stock') || 
        text.includes('stock') ||
        button.href.includes('availability')) {
      button.click();
      return true;
    }
  }
  
  return false;
}

function addAvailabilityToDesktopForm(state) {
  const possibleForms = [
    document.querySelector('#FacetFiltersForm form'),
    document.querySelector('facet-filters-form form'),
    document.querySelector('[data-facet-filters-form] form'),
    document.querySelector('.facets form')
  ];
  
  let form = null;
  for (let f of possibleForms) {
    if (f) {
      form = f;
      break;
    }
  }
  
  if (!form) {
    return false;
  }
  
  // Clean existing availability inputs
  const existing = form.querySelectorAll('input[name*="availability"]');
  existing.forEach(input => input.remove());
  
  // Add availability filter if enabling
  if (state) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'filter.v.availability';
    input.value = '1';
    input.setAttribute('data-desktop-toggle', 'true');
    form.appendChild(input);
  }
  
  // Submit form
  const facetForm = form.closest('facet-filters-form');
  if (facetForm && typeof facetForm.onSubmitForm === 'function') {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    
    const submitEvent = {
      target: form,
      srcElement: form,
      currentTarget: form,
      preventDefault: () => {},
      stopPropagation: () => {},
      type: 'submit'
    };
    
    facetForm.onSubmitForm(searchParams, submitEvent);
    return true;
  } else {
    return false;
  }
}

function updateToggleStates() {
  if (processingToggle) return;
  
  // Check for pending state from page reload
  const pendingState = sessionStorage.getItem('pendingToggleState');
  if (pendingState !== null) {
    const state = pendingState === 'true';
    syncToggleStates(state);
    lastToggleState = state;
    sessionStorage.removeItem('pendingToggleState');
    return;
  }
  
  // Check URL for current state
  const urlParams = new URLSearchParams(window.location.search);
  const isActive = urlParams.get('filter.v.availability') === '1';
  
  syncToggleStates(isActive);
  lastToggleState = isActive;
}

function setupToggleListeners() {
  const desktopToggle = document.getElementById('in-stock-toggle-desktop');
  const mobileToggle = document.getElementById('in-stock-toggle-mobile');
  
  // Setup desktop toggle
  if (desktopToggle) {
    desktopToggle.replaceWith(desktopToggle.cloneNode(true));
    const newDesktopToggle = document.getElementById('in-stock-toggle-desktop');
    
    newDesktopToggle.addEventListener('change', function(e) {
      handleInStockToggle(this);
    });
  }
  
  // Setup mobile toggle with special handling
  if (mobileToggle) {
    mobileToggle.replaceWith(mobileToggle.cloneNode(true));
    const newMobileToggle = document.getElementById('in-stock-toggle-mobile');
    
    newMobileToggle.addEventListener('change', function(e) {
      e.preventDefault();
      e.stopPropagation();
      handleInStockToggle(this);
    });
    
    // Prevent mobile drawer interference
    newMobileToggle.addEventListener('click', function(e) {
      e.stopPropagation();
    });
    
    // Additional mobile event handling
    newMobileToggle.addEventListener('touchend', function(e) {
      e.stopPropagation();
    });
  }
}

// Initialize everything
document.addEventListener('DOMContentLoaded', function() {
  detectPageType();
  updateToggleStates();
  setupToggleListeners();
  
  // Handle AJAX updates
  if (typeof FacetFiltersForm !== 'undefined') {
    const originalRenderFilters = FacetFiltersForm.renderFilters;
    FacetFiltersForm.renderFilters = function(html, event) {
      originalRenderFilters.call(this, html, event);
      
      setTimeout(() => {
        if (!processingToggle) {
          updateToggleStates();
          setupToggleListeners();
        }
      }, 300);
    };
  }
  
  // Handle browser back/forward
  window.addEventListener('popstate', function() {
    setTimeout(() => {
      if (!processingToggle) {
        detectPageType();
        updateToggleStates();
      }
    }, 100);
  });
});

// Cleanup before page unload
window.addEventListener('beforeunload', function() {
  if (processingToggle && lastToggleState !== null) {
    syncToggleStates(lastToggleState);
  }
});